import styled from 'styled-components';
import { COLORS, BREAKPOINTS, SPACING } from '../style';

const TitleContainer = styled.div`
  text-align: center;
  margin-top: ${SPACING.lg};
`;

const MainTitle = styled.h3`
  font-size: 50px;
  color: ${COLORS.blue};
`;

const SubTitle = styled.h4`
  font-size: 18px;
  color: ${COLORS.grey};
  text-align: justify;
  width: 50%;
  margin: 24px auto;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    width: 100%;
  }
`;

interface TitleProps {
  title: string;
  subtitle?: string;
  style?: React.CSSProperties;
}

const Title = ({ title, subtitle, style }: TitleProps) => {
  return (
    <TitleContainer style={style}>
      <MainTitle>{title}</MainTitle>
      {subtitle && <SubTitle>{subtitle}</SubTitle>}
    </TitleContainer>
  );
};

export default Title;